import layermapData from '../data/layermap.json';
import InstanceLibrary from '../libraries/RectangleLibrary';
import labelLibrary from '../libraries/LabelLibrary';
import { hexToRgba } from '../libraries/RectangleLibrary';
import layoutEngine from '../libraries/layoutEngine';
import hierarchyManager from '../libraries/HierarchyManager';
import axios from 'axios';
import polygonLibrary from "../libraries/polygonLibrary";
import api from '../api';

class LayerLibrary {
  constructor() {
    // this.layers = layermapData.layers || [];
    this.layers = [];
    // this.layers = (layermapData.layers || []).map(layer => ({
    //   ...layer,
    //   id: `${layer.layer_number}:${layer.datatype_number}`
    // }));
    this._loaded = false;
    this._loadingPromise = null;

    this.visibilityMap = {};
    this.lockMap = {};
    this.editingMap = {};
    this.sortMode = 'none';
    this._saveTimer = null;              // ⬅️ debounce timer
    this.selectedLayers = [];            // multiple selected layers

    if (this.layers.length > 0) {
      this.selectedLayers = [this.layers[0]];
    }
  }


  

  // =========================
  // Backend I/O helpers
  // =========================
  async persistAllLayers() {
    
    await api.post(`/layers/user/layers`, { layers: this.layers });
    console.log("✅ Layers saved to backend");
  }

  persistDebounced(delay = 350) {
    if (this._saveTimer) clearTimeout(this._saveTimer);
    this._saveTimer = setTimeout(() => {
      this.persistAllLayers().catch(err =>
        console.error("❌ Debounced save failed:", err)
      );
    }, delay);
  }

  // =========================
  // Load / Delete
  // =========================

  
  

  async deleteSelectedLayers() {
    const token = localStorage.getItem("access_token");
    if (!token) {
      console.error("❌ No access token found.");
      return;
    }

    const layersToDelete = this.selectedLayers;

    for (const layer of layersToDelete) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/layers/user/layers/delete`, {
          data: {
            layer_number: layer.layer_number,
            datatype_number: layer.datatype_number,
          },
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log(`✅ Layer deleted: ${layer.layer_name}`);
      } catch (err) {
        console.error("❌ Failed to delete layer:", err);
      }
    }

    // local prune
    this.layers = this.layers.filter(layer => !layersToDelete.includes(layer));
    this.selectedLayers = [];
  }

  setLayers(layers) {
    this.layers = layers;
  }


  async loadUserLayers() {
    const res = await api.get(`/layers/user/layers`);
    

    this.layers = res.data.layers || [];
    // maps init...
    this.visibilityMap = {};
    this.lockMap = {};
    this.editingMap = {};
    this.layers.forEach((l) => {
      const key = `${l.layer_number}:${l.datatype_number}`;
      this.visibilityMap[key] = true;
      this.lockMap[key] = false;
      this.editingMap[key] = false;
    });

     // ⬇️⬇️⬇️ ADD THIS
  if (this.layers.length > 0) {
    this.selectedLayers = [this.layers[0]];
    
  }

    this._loaded = true;             // ✅ mark loaded
    return this.layers;
  }

  // LayerLibrary.js
async ensureLoaded() {
  if (this._loaded && this.layers.length) return;

  const token = localStorage.getItem("access_token");
  if (!token) {
    // token ke bina yahan promise lock mat banao — just return
    return;
  }

  if (!this._loadingPromise) {
    this._loadingPromise = this.loadUserLayers()
      .finally(() => { this._loadingPromise = null; }); // ✅ always clear
  }
  return this._loadingPromise;
}


  // =========================
  // Utils / Sorting
  // =========================
  _getKey(layerNumber, datatypeNumber) {
    return `${layerNumber}:${datatypeNumber}`;
  }

  setSortMode(mode) { this.sortMode = mode; }
  getSortMode() { return this.sortMode; }

  _sortLayers(layers) {
    if (this.sortMode === 'name') {
      return [...layers].sort((a, b) =>
        (a.layer_name + a.datatype_name).localeCompare(b.layer_name + b.datatype_name)
      );
    } else if (this.sortMode === 'number') {
      return [...layers].sort((a, b) =>
        a.layer_number - b.layer_number || a.datatype_number - b.datatype_number
      );
    }
    return layers;
  }

  getAllLayers() { return this._sortLayers(this.layers); }

  getLayerByName(name) {
    if (!name) return null;
    const needle = String(name).trim().toLowerCase();
    // direct match on layer_name or datatype_name combos
    let hit = this.layers.find(l => String(l.layer_name).trim().toLowerCase() === needle);
    if (hit) return hit;
    // try common shorthands like "m1", "nw1" by prefixing
    hit = this.layers.find(l =>
      (`${l.layer_name}`.trim().toLowerCase().replace(/\s+/g,'') === needle) ||
      (`${l.layer_name}${l.datatype_number ?? ''}`.trim().toLowerCase() === needle)
    );
    return hit || null;
  }

  getGroupedLayers() {
    const grouped = {};
    this.getAllLayers().forEach((layer) => {
      const groupKey = `${layer.layer_name} (L${layer.layer_number})`;
      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(layer);
    });
    return grouped;
  }

  getLayerByNumber(layerNumber, datatypeNumber = 0) {
    return this.layers.find(
      (l) =>
        parseInt(l.layer_number) === parseInt(layerNumber) &&
        parseInt(l.datatype_number) === parseInt(datatypeNumber)
    );
  }

  // Sometimes layers might be referenced by different field names
  getLayerByNumbers(layer, datatype) {
    return this.layers.find(l => l.layer === layer && l.datatype === datatype);
  }


  // LayerLibrary.js
getMissingLayersFromUsed(usedLayerIds = []) {
  if (!Array.isArray(usedLayerIds)) return [];

  const existing = new Set(
    this.layers.map(
      l => `${l.layer_number}:${l.datatype_number}`
    )
  );

  return usedLayerIds
    .filter(id => !existing.has(id))
    .map(id => {
      const [layer, datatype] = id.split(":");
      return {
        layer_number: Number(layer),
        datatype_number: Number(datatype)
      };
    });
}

getUsedLayerIdsFromLayout() {
  const usedSet = new Set();

  if (layoutEngine.getAllCellsMap) {
    const allCells = layoutEngine.getAllCellsMap();
    for (const cellName in allCells) {
      const { elements } = allCells[cellName];
      (elements || []).forEach(el => {
        if (el.layerId) {
          usedSet.add(el.layerId);
        } else if (el.layer !== undefined && el.datatype !== undefined) {
          usedSet.add(`${el.layer}:${el.datatype}`);
        }
      });
    }
  }

  return Array.from(usedSet);
}



  // =========================
  // Visibility / Lock
  // =========================
  // LayerLibrary.js
toggleVisibility(layer) {
  const key = this._getKey(layer.layer_number, layer.datatype_number);
  this.visibilityMap[key] = !this.visibilityMap[key];

  const layerId = key;
  const vis = this.visibilityMap[key];

  InstanceLibrary.setLayerVisibility(layerId, vis);
  labelLibrary.setLayerVisibility(layerId, vis);
  polygonLibrary.setLayerVisibility?.(layerId, vis); // ← ADD THIS

  // 🔥 ADD THIS
  // layoutEngine.setLayerVisibility?.(key, vis);

  if (window.canvasEngine) {
    window.canvasEngine.draw();
  }
}


  isLayerVisible(layerNumber, datatypeNumber) {
    const key = this._getKey(layerNumber, datatypeNumber);
    return this.visibilityMap[key] ?? true;
  }

  toggleLock(layer) {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    this.lockMap[key] = !this.lockMap[key];

    const layerId = key;
    const isLocked = this.lockMap[key];

    InstanceLibrary.setAllLock(layerId, isLocked);
    labelLibrary.setAllLock(layerId, isLocked);
    polygonLibrary.setAllLock(layerId, isLocked);

    if (window.canvasEngine) {
      window.canvasEngine.draw();
    }
  }

  isLayerLocked(layerNumber, datatypeNumber) {
    const key = this._getKey(layerNumber, datatypeNumber);
    return this.lockMap[key] ?? false;
  }

  // LayerLibrary.js
lockAll() {
  this.layers.forEach(layer => {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    this.lockMap[key] = true;

    const layerId = key;
    InstanceLibrary.setAllLock(layerId, true);
    labelLibrary.setAllLock(layerId, true);
    polygonLibrary.setAllLock(layerId, true);
  });

  if (window.canvasEngine) window.canvasEngine.draw();
}

unlockAll() {
  this.layers.forEach(layer => {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    this.lockMap[key] = false;

    const layerId = key;
    InstanceLibrary.setAllLock(layerId, false);
    labelLibrary.setAllLock(layerId, false);
    polygonLibrary.setAllLock(layerId, false);
  });

  if (window.canvasEngine) window.canvasEngine.draw();
}

showAll() {
  this.layers.forEach(layer => {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    this.visibilityMap[key] = true;

    const layerId = key;
    InstanceLibrary.setLayerVisibility(layerId, true);
    labelLibrary.setLayerVisibility(layerId, true);
    polygonLibrary.setLayerVisibility?.(layerId, true);
  });

  if (window.canvasEngine) window.canvasEngine.draw();
}

hideAll() {
  this.layers.forEach(layer => {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    this.visibilityMap[key] = false;

    const layerId = key;
    InstanceLibrary.setLayerVisibility(layerId, false);
    labelLibrary.setLayerVisibility(layerId, false);
    polygonLibrary.setLayerVisibility?.(layerId, false);
  });

  if (window.canvasEngine) window.canvasEngine.draw();
}



getUsedLayers() {
  const usedSet = new Set();

  // 1️⃣ Rectangles from InstanceLibrary
  const instanceMap = InstanceLibrary.getAllInstances?.() || {};
  for (const cellName in instanceMap) {
    const cellLayers = instanceMap[cellName] || {};
    for (const layerId in cellLayers) {
      if (cellLayers[layerId]?.length > 0) {
        usedSet.add(layerId);
      }
    }
  }

  // 2️⃣ Labels
  if (labelLibrary.getAllLabels) {
    const allLabels = labelLibrary.getAllLabels();
    for (const layerId in allLabels) {
      if (allLabels[layerId]?.length > 0) {
        usedSet.add(layerId);
      }
    }
  }

  // 3️⃣ Polygons
  if (polygonLibrary.getAllPolygons) {
    const allPolygons = polygonLibrary.getAllPolygons();
    for (const layerId in allPolygons) {
      if (allPolygons[layerId]?.length > 0) {
        usedSet.add(layerId);
      }
    }
  }

  // 4️⃣ Elements from layoutEngine (uploaded + created cells)
  if (layoutEngine.getAllCellsMap) {
    const allCells = layoutEngine.getAllCellsMap();
    for (const cellName in allCells) {
      const { elements } = allCells[cellName];
      (elements || []).forEach(el => {
        if (el.layerId) {
          usedSet.add(el.layerId);
        } else if (el.layer !== undefined && el.datatype !== undefined) {
          usedSet.add(`${el.layer}:${el.datatype}`);
        }
      });
    }
  }

  // ✅ Return only the layers that are in use
  return this.layers.filter(l =>
    usedSet.has(`${l.layer_number}:${l.datatype_number}`)
  );
}


  // =========================
  // Edit-mode + validation
  // =========================
  toggleEdit(layer) {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    this.editingMap[key] = !this.editingMap[key];
  }

  isEditing(layer) {
    const key = this._getKey(layer.layer_number, layer.datatype_number);
    return this.editingMap[key] ?? false;
  }

  isDuplicate1(layer) {
    return this.layers.some(
      (l) =>
        l !== layer &&
        l.layer_name === layer.edit_name &&
        l.datatype_name === layer.edit_dtype
    );
  }

  isDuplicate2(layer) {
    return this.layers.some(
      (l) =>
        l !== layer &&
        l.layer_number === layer.edit_number &&
        l.datatype_number === layer.edit_dtypenum
    );
  }

  checkEditLayer(layer) {
    if (
      (layer.layer_name !== layer.edit_name ||
        layer.datatype_name !== layer.edit_dtype) ||
      (layer.layer_number !== layer.edit_number ||
        layer.datatype_number !== layer.edit_dtypenum)
    ) return true;
    return false;
  }

  // =========================
  // Update (local only here)
  // =========================
  updateLayer(layer, updates) {
    Object.assign(layer, updates);   // NOTE: this one stays (will be overridden below by async one)
  }

  moveLayerUp(layer) {
    const index = this.layers.indexOf(layer);
    if (index > 0) {
      [this.layers[index - 1], this.layers[index]] = [this.layers[index], this.layers[index - 1]];
    }
  }

  moveLayerDown(layer) {
    const index = this.layers.indexOf(layer);
    if (index < this.layers.length - 1) {
      [this.layers[index], this.layers[index + 1]] = [this.layers[index + 1], this.layers[index]];
    }
  }

  // =========================
  // Reassign objects to a new layer
  // =========================
  // updateObjectsLayer(selectedObjects, newLayerId, cellName) {
  //   const newLayer = this.getLayerById(newLayerId);
  //   if (!newLayer) return false;

  //   const layoutCell = layoutEngine.getCellByName(cellName);
  //   const uploadedCell = layoutEngine.getUploadedCell(cellName);
  //   const instanceMap = InstanceLibrary.getAllInstances();
  //   const cellInstances = instanceMap[cellName] || {};

  //   const updatedIds = new Set();

  //   for (const obj of selectedObjects) {
  //     if (!obj.ref || obj.type !== 'rectangle') continue;

  //     const rectId = obj.ref.id;
  //     updatedIds.add(rectId);

  //     const updatedProps = {
  //       layer: newLayer.layer_number,
  //       datatype: newLayer.datatype_number,
  //        layerNumber: newLayer.layer_number,
  //       datatypeNumber: newLayer.datatype_number,
  //       layerId: newLayerId,
  //       fill: hexToRgba(newLayer.color, 0.4), // keep existing visual behavior
  //       stroke: newLayer.color,
  //       visible: true
  //     };

  //     // uploaded rectangles
  //     if (obj.isUploaded && uploadedCell?.elements) {
  //       const el = uploadedCell.elements.find(el => el.id === rectId);
  //       if (el) Object.assign(el, updatedProps);
  //     }

  //     // created rectangles in layoutEngine
  //     if (layoutCell?.elements) {
  //       const el = layoutCell.elements.find(el => el.id === rectId);
  //       if (el) {
  //         Object.assign(el, {
  //           layer: newLayer.layer_number,
  //           datatype: newLayer.datatype_number,
  //           layerNumber: newLayer.layer_number,
  //           datatypeNumber: newLayer.datatype_number,
  //         });
  //       }
  //     }

  //     // update in InstanceLibrary
  //     for (const layerId in cellInstances) {
  //       cellInstances[layerId] = cellInstances[layerId].filter(r => r.id !== rectId);
  //     }

  //     const updatedRect = { ...obj.ref, ...updatedProps, id: rectId };

  //     if (!cellInstances[newLayerId]) cellInstances[newLayerId] = [];
  //     cellInstances[newLayerId].push(updatedRect);
  //   }

  //   // labels
  //   for (const obj of selectedObjects) {
  //     if (obj.type === 'label' && !obj.ref.locked) {
  //       labelLibrary.deleteLabel(cellName, obj.ref.layerId, obj.ref.id);
  //       obj.ref.layerId = newLayerId;
  //       obj.ref.color = newLayer.color;
  //       labelLibrary.addLabel(
  //         cellName,
  //         newLayerId,
  //         obj.ref.x,
  //         obj.ref.y,
  //         obj.ref.text,
  //         newLayer.color
  //       );
  //     }
  //   }

  //   if (window.hierarchyManager && updatedIds.size > 0) {
  //     hierarchyManager.refreshInstanceColors(Array.from(updatedIds));
  //   }

  //   if (window.canvasEngine) window.canvasEngine.draw();

  //   return true;
  // }

  updateObjectsLayer(selectedObjects, newLayerId, cellName) {
  const newLayer = this.getLayerById(newLayerId);
  if (!newLayer) return false;

  const layoutCell = layoutEngine.getCellByName(cellName);
  const uploadedCell = layoutEngine.getUploadedCell(cellName);

  const instanceMap = InstanceLibrary.getAllInstances();
  const cellInstances = instanceMap[cellName] || {};

  const updatedIds = new Set();

  // ================= RECTANGLES =================
  for (const obj of selectedObjects) {
    if (!obj.ref || obj.type !== "rectangle") continue;

    const rectId = obj.ref.id;
    updatedIds.add(rectId);

    const updatedProps = {
      layer: newLayer.layer_number,
      datatype: newLayer.datatype_number,
      layerNumber: newLayer.layer_number,
      datatypeNumber: newLayer.datatype_number,
      layerId: newLayerId,
      fill: hexToRgba(newLayer.color, 0.4),
      stroke: newLayer.color,
      visible: true
    };

    // uploaded rectangle
    if (obj.isUploaded && uploadedCell?.elements) {
      const el = uploadedCell.elements.find(
        el => el.type === "rectangle" && el.id === rectId
      );
      if (el) Object.assign(el, updatedProps);
    }

    // created rectangle
    if (layoutCell?.elements) {
      const el = layoutCell.elements.find(
        el => el.type === "rectangle" && el.id === rectId
      );
      if (el) Object.assign(el, updatedProps);
    }

    // InstanceLibrary cleanup
    for (const lid in cellInstances) {
      cellInstances[lid] = cellInstances[lid].filter(r => r.id !== rectId);
    }

    if (!cellInstances[newLayerId]) cellInstances[newLayerId] = [];
    cellInstances[newLayerId].push({ ...obj.ref, ...updatedProps, id: rectId });
  }

  // ================= POLYGONS =================
  // ================= POLYGONS =================
for (const obj of selectedObjects) {
  if (!obj.ref || obj.type !== "polygon") continue;

  const polyId = obj.ref.id;
  const oldLayerId = obj.ref.layerId;
  const newLayerIdStr = newLayerId;

  const updatedProps = {
    layer: newLayer.layer_number,
    datatype: newLayer.datatype_number,
    layerNumber: newLayer.layer_number,
    datatypeNumber: newLayer.datatype_number,
    layerId: newLayerIdStr,
    fill: hexToRgba(newLayer.color, 0.4),
    stroke: newLayer.color,
    visible: true
  };

  // 🔥 1️⃣ update uploadedCell data (you already do this)
  if (obj.isUploaded && uploadedCell?.elements) {
    const el = uploadedCell.elements.find(
      el => el.type === "polygon" && el.id === polyId
    );
    if (el) Object.assign(el, updatedProps);
  }

  // 🔥 2️⃣ MOVE polygon inside polygonLibrary (THIS WAS MISSING)
  if (polygonLibrary.getAllPolygons) {
    const allPolys = polygonLibrary.getAllPolygons();
    const oldList = allPolys[oldLayerId] || [];

    const poly = oldList.find(p => p.id === polyId);
    if (poly) {
      // remove from old layer
      allPolys[oldLayerId] = oldList.filter(p => p.id !== polyId);

      // add to new layer
      if (!allPolys[newLayerIdStr]) allPolys[newLayerIdStr] = [];
      allPolys[newLayerIdStr].push({ ...poly, ...updatedProps });
    }
  }

  // 🔥 3️⃣ keep ref in sync
  Object.assign(obj.ref, updatedProps);
}


  // ================= LABELS =================
  for (const obj of selectedObjects) {
    if (obj.type === "label" && !obj.ref.locked) {
      labelLibrary.deleteLabel(cellName, obj.ref.layerId, obj.ref.id);
      obj.ref.layerId = newLayerId;
      obj.ref.color = newLayer.color;
      labelLibrary.addLabel(
        cellName,
        newLayerId,
        obj.ref.x,
        obj.ref.y,
        obj.ref.text,
        newLayer.color
      );
    }
  }

  if (window.hierarchyManager && updatedIds.size > 0) {
    hierarchyManager.refreshInstanceColors(Array.from(updatedIds));
  }

  if (window.canvasEngine) window.canvasEngine.draw();

  return true;
}




  // =========================
  // Selection state
  // =========================
  selectLayer(layer, ctrlKey = false) {
    if (ctrlKey) {
      const exists = this.selectedLayers.includes(layer);
      if (exists) {
        this.selectedLayers = this.selectedLayers.filter(l => l !== layer);
      } else {
        this.selectedLayers.push(layer);
      }
    } else {
      this.selectedLayers = [layer];
    }
  }

  getSelectedLayers() { return this.selectedLayers; }
  clearSelection() { this.selectedLayers = []; }
  isLayerSelected(layer) { return this.selectedLayers.includes(layer); }

  // =========================
  // Live color / opacity updates + persist
  // =========================
  updateColor(layer, color) {
    layer.color = color;

    const layerId = `${layer.layer_number}:${layer.datatype_number}`;

    InstanceLibrary.updateColorByLayer(layerId, color);
    labelLibrary.updateColorByLayer(layerId, color);
    polygonLibrary.updateColorByLayer(layerId, color);

    if (window.canvasEngine) window.canvasEngine.draw();

    // backend (debounced bulk save)
    this.persistDebounced();
  }

  updateOpacity(layer, opacity) {
    // update nested pattern.opacity
    if (layer.pattern) {
      layer.pattern.opacity = opacity;
    }

    const layerId = `${layer.layer_number}:${layer.datatype_number}`;

    InstanceLibrary.updateOpacityByLayer?.(layerId, opacity);
    labelLibrary.updateOpacityByLayer?.(layerId, opacity);
    polygonLibrary.updateOpacityByLayer?.(layerId, opacity);

    if (window.canvasEngine) window.canvasEngine.draw();

    // backend (debounced bulk save)
    this.persistDebounced();
  }

  // =========================
  // Lookups
  // =========================
  getSelectedLayerId() {
    const selected = this.getSelectedLayers();
    if (selected.length === 0) return null;
    const l = selected[0];
    return `${l.layer_number}:${l.datatype_number}`;
  }

  getLayerById(layerId) {
    if (!layerId || typeof layerId !== 'string' || !layerId.includes(':')) return null;

    const [layer_number, datatype_number] = layerId.split(':');
    return this.layers.find(
      (l) =>
        String(l.layer_number) === String(layer_number) &&
        String(l.datatype_number) === String(datatype_number)
    );
  }

  getLabelById(labelId) {
    for (const layerId in this.labels) {
      const found = this.labels[layerId].find(label => label.id === labelId);
      if (found) return found;
    }
    return null;
  }

  // =========================
  // Edit-save (PERSIST) — keeps name the same
  // =========================
  async updateLayer(layer, updates) {         // ⬅️ same name/signature as before
    // 1) local update
    Object.assign(layer, updates);

    // 2) backend persist via bulk POST (no 404)
    const token = localStorage.getItem("access_token");
    try {
      await this.persistAllLayers();
      console.log("✅ Layer updated in backend (edit save)");
      // NOTE: agar layer_number/datatype_number change huye,
      // maps turant rebuild chahiye to yahan:
      // await this.loadUserLayers();
    } catch (err) {
      console.error("❌ Failed to update layer in backend:", err);
    }
  }

  // =========================
  // Reorder
  // =========================
  reorder(fromIndex, toIndex) {
    if (
      fromIndex < 0 ||
      toIndex < 0 ||
      fromIndex >= this.layers.length ||
      toIndex >= this.layers.length ||
      fromIndex === toIndex
    ) return;

    const moved = this.layers.splice(fromIndex, 1)[0];
    this.layers.splice(toIndex, 0, moved);
  }
}

const layerLibrary = new LayerLibrary();
export default layerLibrary;
